import React from "react";
import { Button } from "react-bootstrap";
import { getAuthToken, clearAuthToken } from "../utils/auth";
import { useNavigate } from "react-router-dom";

export default function UnauthenticatedPage() {
  const navigate = useNavigate();
  const token = getAuthToken();

  return (
    <div style={{ padding: 20 }} className="bg-white w-full h-full">
      <h2>Not authenticated</h2>
      <p>
        This page requires authentication. You can provide a one-shot token via
        the URL query parameter `?jwt=&lt;token&gt;` or set an environment token
        for local testing.
      </p>
      {token ? (
        <div>
          <p style={{ color: "green" }}>A token exists in session storage.</p>
          <Button
            variant="outline-danger"
            onClick={() => {
              clearAuthToken();
              navigate("/");
            }}
          >
            Clear token and go home
          </Button>
        </div>
      ) : (
        <div>
          <p style={{ color: "red" }}>No token found.</p>
          <div style={{ marginTop: 12 }}>
            <Button
              onClick={() => {
                // convenience: navigate home so user can paste ?jwt= in address bar
                navigate("/");
              }}
            >
              Back to home (add ?jwt=... to URL)
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
